<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
    <!-- alert -->
    <div>
      <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>
    <!-- alert end -->
    <!-- Title-->
    <header-component :headerTitle="headerText" />
    <!-- Title end -->
    <!-- Tabs -->
    <v-card class="v-card-100 mt-0">
      <v-tabs color="primary" v-model="selected_tab">
        <v-tab style="text-transform:none!important;" @click="loadData(tab, 'tab_clicked')" v-for="(tab, index) in tabs"
          :key="index" class="tab-color">{{ tab }}</v-tab>
      </v-tabs>
    </v-card>
    <!-- popups -->
    <v-row justify="center">
      <v-dialog v-model="CreateRequestPopup" persistent max-width="700px">
        <v-card class="v-card-100 mt-0">
          <v-card-title class="d-flex align-center">
            <span>Create Request</span><br>
            <v-spacer></v-spacer>
            <v-btn icon variant="solo" @click="CreateRequestPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="2" class="border-opacity-50 m-0"/>
          <v-card-text class="content-box">
            <v-row style="padding:20px 18px 0px 18px;">
              <v-combobox prepend-inner-icon="mdi-magnify" v-model="assignExecutive" variant="outlined" :items="assignee_executive" item-title="full_name_with_employee_code" item-value="user_id" label="Assign Executive" outlined class="ma-2" style="max-width: 300px;" return-object> </v-combobox>
            </v-row>
            <v-flex style="overflow: auto">
              <v-data-table hover
                density="compact"
                :search="search"
                v-model="selectedItems"
                :hide-default-footer="true"
                :headers="create_request_headers"
                :items="create_request_table_data"
                :items-per-page="itemSize"
                :items-per-page-options="[5, 10, 15]"
                :server-items-length="totalItems"
                :show-select="false"
                :disable-pagination="false"
                fixed-header
                height="310px" 
                :loading="loading"
                loading-text="Loading Data... Please wait"
                class="elevation-1 popup_table" >
                <template #[`item.actions`]="{ item }">
                    <img @click="deleteEvent(item,'create')" src="@/assets/images/delete_red.png" title="Delete item" />
                  </template>
                <template #[`item.invoice_number`]="{ item }">
                  <span>{{ item.invoice_number ? item.invoice_number : "N/A" }}</span>
                </template>
                <template #[`item.serial_number_1`]="{ item }">
                  <span>{{ item.serial_number_1 ? item.serial_number_1 : "N/A" }}</span>
                </template>
                <template #[`item.article_id`]="{ item }">
                  <span>{{ item.article_id ? item.article_id : "N/A" }}</span>
                </template>
                <template v-slot:footer>
                  <v-row class="ml-2 pb-0">
                    <v-col cols="2" sm="2" class="PaddingItemPerPage d-flex pt-3 pl-0">
                      <label class="pt-3">Rows Per Page</label>
                      <v-select v-model="itemSize" :items="itemSizes" class="custom-pagination-ui" @change="handleItemSizeChange" outlined style="width: 80px;margin-left: 120px;position:absolute;"></v-select>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="6" sm="6" class="PaddingItemPerPage float-right custom-column-ui">
                      <label class="pt-3 mt-0" style="position:absolute;margin-left:-10px;" v-if="totalItemCount > 0">{{ (item - 1) * itemSize + 1 }} - {{ Math.min(item * itemSize, totalItemCount) }} of {{ totalItemCount }}</label>
                      <v-pagination v-model="item" :length="totalItems" total-visible="7" class="custom-pagination-ui" @input="handleItemChange" circle></v-pagination>
                    </v-col>
                  </v-row>
                </template>
              </v-data-table> 
            </v-flex>
          </v-card-text>
          <v-card-actions class="margin-10" style="justify-content: center;">
            <!-- <v-spacer></v-spacer> -->
            <v-btn size="small" variant="outlined" color="primary" class="btn-cancel mr-2 mb-3 text-none" @click="CreateRequestPopup = false">Cancel</v-btn>
            <v-btn size="small" variant="flat" color="primary" class="mb-3 text-none" :disabled="!assignExecutive" @click="submitRequest">Submit</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- edit request -->
    <v-row justify="center">
      <v-dialog v-model="EditRequestPopup" persistent max-width="700px">
        <v-card class="v-card-100 mt-0">
          <v-card-title class="d-flex align-center">
            <span>Edit Request</span><br>
            <v-spacer></v-spacer>
            <v-btn icon variant="solo" @click="EditRequestPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="2" class="border-opacity-50 m-0"/>
          <v-card-text class="content-box">
            <v-row style="padding:20px 18px 0px 18px;">
                <v-combobox prepend-inner-icon="mdi-magnify" v-model="EditAssignExecutive" :items="edit_assignee_executive" item-title="full_name_with_employee_code" item-value="user_id" label="Assign Executive" outlined class="ma-2" :loading="executive_loading" style="max-width: 300px;" return-object> </v-combobox>
            </v-row>
            <v-flex style="overflow: auto">
              <v-data-table hover
                density="compact"
                :search="search"
                v-model="editSelected"
                :headers="edit_request_headers"
                :items="edit_request_table_data"
                :items-per-page="itemSize"
                :items-per-page-options="[5, 10, 15]"
                :server-items-length="totalItems"
                fixed-header
                height="310px" 
                :loading="loading"
                loading-text="Loading Data... Please wait"
                class="elevation-1 popup_table" 
                :show-select="false"
                :hide-default-footer="true"
                :disable-pagination="false"
                >
                <template #[`item.actions`]="{ item }">
                    <img @click="deleteEvent(item,'edit')" src="@/assets/images/delete_red.png" title="Delete item" />
                  </template>
                <template #[`item.invoice_number`]="{ item }">
                  <span>{{ item.invoice_number ? item.invoice_number : "N/A" }}</span>
                </template>
                <template v-slot:footer>
                  <v-row class="ml-2 pb-0">
                    <v-col cols="2" sm="2" class="PaddingItemPerPage d-flex pt-3 pl-0">
                      <label class="pt-3">Rows Per Page</label>
                      <v-select v-model="itemSize" :items="itemSizes" class="custom-pagination-ui" @change="handleItemSizeChange" outlined style="width: 80px;margin-left: 120px;position:absolute;"></v-select>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="6" sm="6" class="PaddingItemPerPage custom-column-ui">
                      <label class="pt-3 mt-0" style="position:absolute;margin-left:-10px;" v-if="totalItemCount > 0">{{ (item - 1) * itemSize + 1 }} - {{ Math.min(item * itemSize, totalItemCount) }} of {{ totalItemCount }}</label>
                      <v-pagination v-model="item" :length="totalItems" total-visible="7" class="custom-pagination-ui" @input="handleItemChange" circle></v-pagination>
                    </v-col>
                  </v-row>
                </template>
              </v-data-table>
            </v-flex>
          </v-card-text>
          <v-card-actions class="margin-10" style="justify-content: center;">
            <!-- <v-spacer></v-spacer> -->
            <v-btn size="small" variant="outlined" color="primary" class="btn-cancel mr-2 mb-3 text-none" @click="EditRequestPopup = false">Cancel</v-btn>
            <v-btn size="small" variant="flat" color="primary" class="mb-3 text-none" :disabled="!EditAssignExecutive" @click="submitEditRequest">Submit</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="successPopup" persistent max-width="424px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <v-spacer></v-spacer>
            <v-btn variant="solo" @click="successPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text-center">
            <span> {{ SuccessMessage }}</span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="flat" color="primary" class="mb-3 text-none" @click="afterClickOkLoadData">Ok</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- popups end -->
    <!-- Search, Action Buttons, Filter -->
    <v-card-title style="padding: 20px; margin-top: 25px;" class="action-style pb-1">
      <!-- Search Fields -->
      <v-row>
        <v-autocomplete v-model="select_field" :items="select_field_items"  item-value="id" style="max-width: 150px;" item-title="name" label="Select Field" class="mr-4 py-3" variant="outlined"></v-autocomplete >
        <v-text-field prepend-inner-icon="mdi-magnify" v-model="search_tag" label="Search" class="search_style py-3" variant="outlined" style="max-width: 300px;" v-on:keyup.enter="loadData(active_tab)"></v-text-field>
        <v-spacer></v-spacer>
        <!-- Action Buttons -->
        <v-col cols="3" sm="3" class="p-0">
          <v-card-actions class="float-right px-0 mt-1"  style="min-height: 56px !important;">
            <v-btn class="mb-8 text-none" size="x-large" variant="flat" color="primary" :disabled="selected == 0" v-if="active_tab !== 'Request Tracker'" @click="CreateRequest">Create Request</v-btn>
            <v-btn class="mb-8 text-none" size="x-large" variant="flat" color="primary" :disabled="isButtonDisabled" v-if="active_tab === 'Request Tracker'" @click="EditRequest()">Edit Request</v-btn>
          </v-card-actions>
        </v-col>
      </v-row>
    </v-card-title>

    <!-- Data Table -->
    <v-layout column>
      <v-col cols="12" style="overflow: auto;" class="p-0">
        <v-data-table hover
          :dense="true"
          :search="search"
          v-model="selected"
          show-select
          disable-pagination
          :hide-default-footer="true"
          :headers="headers"
          :items="table_data"
          :items-per-page="pageSize"
          :page="page"
          fixed-header
          height="100%" 
          :loading="loading"
          loading-text="Loading Data... Please wait"
          class="elevation-1" >
          <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers">
              <span v-if="header.key == 'completion_timestamp'">
                <span>{{ formatDate(item.completion_timestamp) }}</span>
              </span> 
              <span v-else-if="header.key == 'created_at'">
                <span>{{ formatDate(item.created_at) }}</span>
              </span> 
              <span v-else-if="header.key !== 'images' && item[header.key]">
                <span v-tooltip="item[header.key]">
                  {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                </span>
              </span>
              <span v-else>-</span>
            </template>
          <!-- <template v-for="(header, index) in headers" v-slot:[`item.${header.value}`]="{ item }" >
            <span v-if="header.value !== 'created_at'">
              <span v-if="item[header.value] !== null && item[header.value] !== ''">{{ item[header.value] }}</span>
              <span v-else>-</span>
            </span>
            <span v-else>
              <span>{{ formatDate(item.created_at) }}</span>
            </span>
          </template>
          <template #[`item.completion_timestamp`]="{ item }">
            <span>{{ formatDate(item.completion_timestamp) }}</span>
          </template> -->
          <template #bottom></template>
        </v-data-table>
      </v-col>
    </v-layout>
    <!-- pagination display -->
             <div>
                <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-2 mb-0"
                />
            </div>
    <!-- tabs end -->
  </v-card>
</template>
<script>
  import HeaderComponent from "../../../../commoncomponents/HeaderComponent.vue";
  import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
  export default {
    components:{
      HeaderComponent,
    },
    data(){
      return{
        headerText:"Service Request",
        tabs:[
            "Service Request",
            "Repair Request",
            "Replacement Request",
            "Request Tracker"
        ],
        active_tab:"Service Request",
        selected:[],
        table_data: [],
        headers:[
          { title: "CRM Ticket No", key:"crm_ticket_no", align: "start", sortable: false },
          { title: "Sub Request ID", key: "sub_request_id" },
          { title: "Service Request No", key: "service_request_id" },
          { title: "Article ID", key: "article_id" },
          { title: "Creation Date", key: "client_name" },
          { title: "Location", key: "location" },
          { title: "Customer Entity Name", key: "testing_location" },
        ],
        alert: false,
        selected_tab: 0,
        alert_type:"success",
        alert_message:'',
        search_tag:'',
        search:'',
        loading: false,
        page : 1 ,
        totalPages : 1,
        item: 1,
        totalItems: 1,
        itemSize: 10,
        itemSizes: [5, 10, 15],
        pageSize: defaultPageSize,
        pageSizes: defaultPageSizes,
        totalCount: '',
        totalItemCount: '',
        CreateRequestPopup : false,
        assignExecutive: [],
        assignee_executive :[],
        create_request_headers :[],
        create_request_table_data :[],
        selectedItems: [],
        successPopup : false,
        SuccessMessage: '',
        select_field: [],
        select_field_items: [],
        EditRequestPopup : false,
        EditAssignExecutive: [],
        edit_assignee_executive : [],
        edit_request_headers: [],
        edit_request_table_data: [],
        editSelected: [],
        executive_loading: false,
        select_field_items: []
      }
    },
    created() {
      const tab = this.$store.state.active_tab
      if(this.tabs.includes(tab)){
        this.loadData(tab);
        this.selected_tab = this.tabs.indexOf(tab)
      } else {
        this.loadData('Service Request');
        this.selected_tab = 0
      }
    },
    computed:{
      isButtonDisabled() {
        return this.selected.length === 0 || this.selected.some(item => item.status === 'closed') || this.selected.some(item => item.status === 'in_progress');
      }
    },
    methods:{
      loadData(tab, tab_action){
        if (tab_action) {
          this.search_tag = ''
          this.select_field = []
        }
        this.loading = true
        this.selected = []
        this.active_tab = tab
        this.table_data = []
        this.page = 1
        this.totalPages = 1
        this.$store.commit('setActiveTab',{ 'active_tab' : tab});
        if(tab == 'Service Request'){
          (this.headers = [
            { title: "CRM Ticket No", key:"crm_ticket_no", align: "start", sortable: false , minWidth: '200px'},
            { title: "Sub Request ID", key: "sub_request_id", minWidth: '200px' },
            { title: "Service Request No", key: "service_request_id", minWidth: '200px' },
            { title: "Article ID", key: "article_id", minWidth: '200px' },
            { title: "Creation Date", key: "creation_date_and_time", minWidth: '200px' },
            { title: "Location", key: "location" , minWidth: '200px'},
            { title: "Customer Entity Name", key: "customer_name", minWidth: '220px' },
          ]);
          this.getServiceRequest(),
          this.select_field_items= [
            {
              "name":"CRM Ticket No",
              "id": "crm_ticket_no"
            },
            {
              "name":"Sub Request ID",
              "id": "sub_request_id"
            },
            {
              "name":"Service Request No",
              "id": "service_request_id"
            },
            {
              "name":"Article ID",
              "id": "article_id"
            }
          ]
        }
        if(tab == 'Repair Request'){
          (this.headers = [
            { title: "CRM Ticket No", key:"crm_ticket_no", align: "start", sortable: false, minWidth: '200px' },
            { title: "Sub Request ID", align: "start", sortable: false, key:"sub_request_id", minWidth: '200px'},
            { title: "Repair Request No", key: "repair_request_id", minWidth: '200px' },
            { title: "Article ID", key: "article_id", minWidth: '200px' },
            { title: "Request Type", key: "request_type", minWidth: '200px' },
            { title: "Creation Date", key: "creation_date_and_time", minWidth: '200px' },
            { title: "Location", key: "location", minWidth: '200px' },
            { title: "Customer Entity Name", key: "customer_name", minWidth: '220px' },
          ]);
          this.getRepairRequest(),
          this.select_field_items= [
            {
              "name":"CRM Ticket No",
              "id": "crm_ticket_no"
            },
            {
              "name":"Sub Request ID",
              "id": "sub_request_id"
            },
            {
              "name":"Repair Request No",
              "id": "repair_request_id"
            },
            {
              "name":"Article ID",
              "id": "article_id"
            }
          ]
        }
        if(tab == 'Replacement Request'){
          (this.headers = [
            { title: "CRM Ticket No", key:"crm_ticket_no", align: "start", sortable: false, minWidth: '200px' },
            { title: "Sub Request ID", align: "start", sortable: false, key:"sub_request_id", minWidth: '200px'},
            { title: "Replacement Request No", key: "replacement_request_id", minWidth: '230px' },
            { title: "Article ID", key: "article_id", minWidth: '200px'},
            { title: "Request Type", key: "request_type", minWidth: '200px' },
            { title: "Creation Date", key: "creation_date_and_time", minWidth: '200px' },
            { title: "Location", key: "location", minWidth: '200px' },
            { title: "Customer Entity Name", key:"customer_name", minWidth: '220px'},
          ]);
          this.getReplacementRequest(),
          this.select_field_items= [
            {
              "name":"CRM Ticket No",
              "id": "crm_ticket_no"
            },
            {
              "name":"Sub Request ID",
              "id": "sub_request_id"
            },
            {
              "name":"Replacement Request No",
              "id": "replacement_request_id"
            },
            {
              "name":"Article ID",
              "id": "article_id"
            }
          ]
        } if(tab == 'Request Tracker'){
          (this.headers = [
            { title: "Sub Request ID", align: "start", sortable: false, key:"sub_request_id", minWidth: '200px'},
            { title: "Creation Date & Time", key: "created_at", minWidth: '220px' },
            { title: "Request Type", key: "fta_request_type" , minWidth: '200px'},
            { title: "Assigned To", key:"assigned_field_executive", minWidth: '200px'},
            { title: "Status", key: "status", minWidth: '200px' },
            { title: "Completion Time & Date", key: "completion_timestamp", minWidth: '220px' },
            { title: "Location", key:"location", minWidth: '200px'},
          ]);
          this.getRequestTracker()
          this.select_field_items = [
            {
              "name":"Sub Request ID",
              "id": "sub_request_id"
            },
          ]
        } 
      },
      formatDate(isoDate) {
        if (!isoDate) return "-";
        const date = new Date(isoDate);
        if (isNaN(date.getTime())) return "-";
        const options = {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true
        };
        return date.toLocaleString("en-GB", options);
      },
      postSelectedRequest(){
        const params = {
          page: this.item,
          per_page: this.itemSize,
          ids: [
            this.selected.map(item => item.id)
          ],
          fta_request_type: this.active_tab.toLowerCase() //"service request", "replacement request", "repair request", "validation request", "request tracker"

        };
        
        this.$httpSecured
          .post("/api/v1/warehouse/fta/request_trackers/edit_request_list", params)
          .then(response => {
            if (response.data && response.data.request_trackers) {
                this.create_request_table_data = response.data.request_trackers;
                this.edit_request_table_data = response.data.request_trackers;
                this.totalItems = response.data.meta.total_pages;
                this.totalItemCount = response.data.meta.total_count;
                this.loading = false
              } else {
                this.showAlert("error", "No Data Found");
                this.loading = false
              }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      getServiceRequest(){
        const params = {
          search_text: this.search_tag,
          search_key: this.select_field,
          page: this.page,
          per_page: this.pageSize
        };
        this.$httpSecured
          .post("/api/v1/warehouse/fta/service_requests", params)
          .then(response => {
            if (response.data && response.data['fta/service_requests']) {
                this.table_data = response.data['fta/service_requests'];
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count;
                this.loading = false
              } else {
                this.showAlert("error", "No Data Found");
                this.loading = false
              }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      getRepairRequest(){
        const params = {
          search_text: this.search_tag,
          search_key: this.select_field,
          page: this.page,
          per_page: this.pageSize
        };
        this.$httpSecured
          .post("/api/v1/warehouse/fta/repair_requests", params)
          .then(response => {
            if (response.data && response.data['fta/repair_requests']) {
                this.table_data = response.data['fta/repair_requests'];
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count;
                this.loading = false
              } else {
                this.showAlert("error", "No Data Found");
                this.loading = false
              }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      getReplacementRequest(){
        const params = {
          search_text: this.search_tag,
          search_key: this.select_field,
          page: this.page,
          per_page: this.pageSize
        };
        this.$httpSecured
          .post("/api/v1/warehouse/fta/replacement_requests", params)
          .then(response => {
            if (response.data && response.data['fta/replacement_requests']) {
                this.table_data = response.data['fta/replacement_requests'];
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count;
                this.loading = false
              } else {
                this.showAlert("error", "No Data Found");
                this.loading = false
              }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      getRequestTracker(){
        const params = {
          search_text: this.search_tag,
          search_key: this.select_field,
          page: this.page,
          per_page: this.pageSize
        };
        this.$httpSecured
          .post("/api/v1/warehouse/fta/request_trackers", params)
          .then(response => {
            if (response.data && response.data['request_trackers']) {
                this.table_data = response.data['request_trackers'];
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count;
                this.loading = false
              } else {
                this.showAlert("error", "No Data Found");
                this.loading = false
              }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      CreateRequest(){
        this.postSelectedRequest();
        this.CreateRequestPopup = true
        this.assignExecutive = null
        // this.create_request_table_data = this.selected
        this.create_request_headers = [
          { title: "Article ID", align: "start", sortable: false, key:"article_id"},
          { title: "Serial Number", key: "serial_number_1" },
          { title: "Invoice Number", key: "invoice_number" },
          { title: "", key: "actions"},
        ]

        const params = {
          partner_name: 'internal',
        };
        if (this.active_tab === 'Service Request') {
          var apiUrl = '/api/v1/warehouse/fta/service_requests/get_executives'
        } 
        if (this.active_tab === 'Repair Request') {
          var  apiUrl = '/api/v1/warehouse/fta/repair_requests/get_executives'
        } 
        if (this.active_tab === 'Replacement Request') {
          var apiUrl = '/api/v1/warehouse/fta/replacement_requests/get_executives'
        }
        this.$httpSecured
          .get(apiUrl, params)
            .then(response => {
            if (response.data) {
              this.assignee_executive = response.data.executives_user_with_id
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => { 
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
        });
      },
      EditRequest(){
        this.postSelectedRequest();
        this.EditRequestPopup = true
        // this.edit_request_table_data = this.selected
        this.EditAssignExecutive = null
        this.edit_request_headers = [
          { title: "Article ID", align: "start", sortable: false, key:"article_ids"},
          { title: "Serial Number", key: "serial_numbers" },
          { title: "Invoice Number", key: "invoice_number" },
          { title: "", key: "actions"},
        ]
        this.executive_loading = true
        this.$httpSecured
          .get('/api/v1/warehouse/fta/grading_requests/get_executives')
            .then(response => {
            if (response.data) {  
              this.edit_assignee_executive = response.data.executives_user_with_id
              this.executive_loading = false;
            } else {
              this.executive_loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => { 
            this.showAlert("error", "Something went wrong from Network" + error);
            this.executive_loading = false;
        });
      },
      deleteEvent(item,action){
        if(action == 'create'){
          const index = this.create_request_table_data.indexOf(item);
          this.create_request_table_data.splice(index, 1);
          this.inv_id = this.create_request_table_data.map(x => x.id)
          if (this.create_request_table_data.length == 0) {
            this.create_request_table_data = []
            this.CreateRequestPopup = false;
            this.loadData(this.active_tab)
            this.selected = []
          }
        } else {
          const index = this.edit_request_table_data.indexOf(item);
          this.edit_request_table_data.splice(index, 1);
          this.inv_id = this.edit_request_table_data.map(x => x.id)
          if (this.edit_request_table_data.length == 0) {
            this.edit_request_table_data = []
            this.EditRequestPopup = false;
            this.loadData(this.active_tab)
            this.selected = []
          }
        }
      },
      submitRequest(){
        this.number++;
        const item_id = this.create_request_table_data.map(x => x.id)
        if (this.active_tab === 'Service Request') {
          var apiUrl = '/api/v1/warehouse/fta/service_requests/assign_request'
        } 
        if (this.active_tab === 'Repair Request') {
          var  apiUrl = '/api/v1/warehouse/fta/repair_requests/assign_request'
        } 
        if (this.active_tab === 'Replacement Request') {
          var apiUrl = '/api/v1/warehouse/fta/replacement_requests/assign_request'
        }

        this.$httpSecured.post(apiUrl, {
          "ids": item_id,
          "service_technician_id": this.assignExecutive.service_technician_id,
        },)
          .then(response => {
            if (response.data) {
              this.SuccessMessage = response.data.message;
              this.successPopup = true;
              this.CreateRequestPopup = false;
            } else {
              this.showAlert("error", "No Data Found");
              this.number = 0;
            }
          }).catch(error => {
            this.showAlert("error", error.response.data.message);
            this.number = 0;
            this.loading = false;

          });
      },
      submitEditRequest(){
        const item_id = this.edit_request_table_data.map(x => x.id)
        // const service_request = this.selected.map(item => item.fta_request_type)
        const service_request = this.edit_request_table_data.map(item => item.fta_request_type).join(''); 
        // const executive_name = String(this.EditAssignExecutive); 
        // alert(executive_name)
        this.$httpSecured.post('/api/v1/warehouse/fta/request_trackers/assign_request', {
          "ids": item_id,
          "fta_request_type": service_request,
          "user_id": this.EditAssignExecutive.user_id,
        },)
          .then(response => {
            if (response.data) {
              this.SuccessMessage = response.data.message;
              this.successPopup = true;
              this.EditRequestPopup = false;
            } else {
              this.showAlert("error", "No Data Found");
              this.number = 0;
            }
          }).catch(error => {
            this.showAlert("error", error.response.data.message);
            this.number = 0;
            this.loading = false;
            this.EditRequestPopup = false;
          });
      },
      afterClickOkLoadData(){
        this.successPopup = false
        this.loadData(this.active_tab)
      },
      scrollToTop() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      },
      showAlert(alert_type, alert_message) {
        this.scrollToTop();
        this.alert = true;
        this.alert_type = alert_type;
        this.alert_message = alert_message;
        this.alertTimeOut();
      },
      alertTimeOut() {
        setTimeout(() => {
          this.alert = false;
        }, 3000);
      },
      handlePageChange(value) {
        this.page = value;
        if (this.active_tab == 'Service Request') {
          this.getServiceRequest()
        } else if (this.active_tab == 'Repair Request') {
          this.getRepairRequest()
        } else if (this.active_tab == 'Replacement Request') {
          this.getReplacementRequest()
        } else if (this.active_tab == 'Request Tracker') {
          this.getRequestTracker() 
        }
      },
      //  To handle the page size change
      handlePageSizeChange(size) {
        this.pageSize = size;
        this.page = 1
        if (this.active_tab == 'Service Request') {
          this.getServiceRequest()
        } else if (this.active_tab == 'Repair Request') {
          this.getRepairRequest()
        } else if (this.active_tab == 'Replacement Request') {
          this.getReplacementRequest()
        } else if (this.active_tab == 'Request Tracker') {
          this.getRequestTracker() 
        }
      },
      handleItemChange(value) {
        this.item = value;
        this.postSelectedRequest()
      },
      //  To handle the page size change
      handleItemSizeChange(size) {
        this.itemSize = size;
        this.item = 1
        this.postSelectedRequest()
        
      },
    }
  }
</script>
<style scoped>
  .item-selected{
    margin-top: 23px;
    position: absolute;
    left: 41%;
  }
  .content-box .v-data-table{
    height: 391px !important;
  }
  :deep(.popup_table .v-data-table-header>tr>th){
    font-weight: 500 !important;
    color: black !important;
    font-size: 14px !important;
  }
  :deep(.popup_table .v-data-table-header>tr){
      box-shadow: 1px 1px 3px 0px #A2A3B4 !important;
   }
   :deep(.popup_table .v-data-footer .v-data-footer__select){
    margin-right: 230px !important;
  }
  .v-data-table {
    height: calc(var(--vh, 1vh) * 100 - 310px) !important;
  }
</style>